import { createContext, useContext, useState } from 'react';
import { useCookie } from '../utils/cookie';
import Loading from '../components/Loading';
import { useSelector } from 'react-redux';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const { set, get, remove } = useCookie();
    const [auth, setAuth] = useState(() => {
        const token = get('auth_token');
        if (token) { global.auth_token = token }
        const user = get('user');
        return token ? { isAuthenticated: true, token, userDetails: user } : { isAuthenticated: false };
    });
    const { loading } = useSelector((state) => state.base);

    const login = (token, userDetails) => {
        set('auth_token', token);
        setAuth({ isAuthenticated: true, token, userDetails });
    };

    const logout = () => {
        remove('auth_token');
        setAuth({ isAuthenticated: false });
    };

    return (
        <AuthContext.Provider key="auth-provider" value={{ auth, login, logout }}>
            {children}
            <Loading loading={loading} />
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);